import { Grid } from '@mui/material';
import { ReactNode } from 'react';

import { SettingsHeader } from '../../../components/SettingsHeader';
import SettingsIndex from '../../../components/SettingsIndex';
import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

type PropsType = {
  title: string;
  indexLabel: string;
  children: ReactNode;
};

const DeleteRequestsLayout = ({ title, children, indexLabel }: PropsType) => (
  <Grid container columnSpacing={3} rowSpacing={4}>
    <Grid item xs={12}>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.DATA_PRIVACY,
          Pages['DELETE_REQUESTS']
        )}
      />
      <SettingsHeader title={title} />
    </Grid>

    <Grid item xs={3}>
      <SettingsIndex index="" options={[{ label: indexLabel, url: '/delete-requests' }]} />
    </Grid>
    <Grid item xs={9}>
      {children}
    </Grid>
  </Grid>
);

export default DeleteRequestsLayout;
